import { PDFDocumentProxy } from 'pdfjs-dist'

export default class PdfDocumentWrapper {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly document: PDFDocumentProxy,
  ) {}
}
